import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import MasterPage from "../../../layouts/MasterPage";
import AuthenticationManager from "../../../services/StorageJWT";

const Main2 = () => {
  const auth = new AuthenticationManager();
  const navigate = useNavigate();

  const onHelp = (type) => {
    navigate("/two/helps", { state: { type: type } });
  };
  return (
    <MasterPage>
      <div className="structure-page-8 login body " dir="ltr">
        <div className="game-two-main">
          <div className="row">
            <div className="col-4">
              <img
                role="button"
                onClick={() => onHelp("magazine")}
                src="/images/two/1.svg"
                alt="نامه"
                className="img-fluid m-auto  "
              />
            </div>
            <div className="col-4 d-grid ">
              <img
                role="button"
                onClick={() => onHelp("broshor")}
                src="/images/two/2.svg"
                alt="نامه"
                className="img-fluid m-auto  "
              />
            </div>
            <div className="col-4">
              <img
                role="button"
                onClick={() => onHelp("arian")}
                src="/images/two/3.svg"
                alt="نامه"
                className="img-fluid m-auto  "
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4"></div>
            <div className="col-4">
              <img
                role="button"
                onClick={() => onHelp("card")}
                src="/images/two/4.svg"
                alt="نامه"
                className="img-fluid m-auto  "
              />
            </div>
            <div className="col-4"></div>
          </div>
          <div className="row justify-content-around ">
            <div className="col-4">
              <img
                role="button"
                src="/images/two/5.svg"
                alt="ریسمان"
                onClick={() => onHelp("money2")}
                className="img-fluid m-auto mb-2 "
              />
            </div>
            <div className="col-4">
              <img
                role="button"
                src="/images/two/6.svg"
                alt="نقشه"
                onClick={() => onHelp("money")}
                className="img-fluid m-auto mb-2 "
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <img
                role="button"
                onClick={() => onHelp("postal2")}
                src="/images/two/7.svg"
                alt="نامه"
                className="img-fluid m-auto  "
              />
            </div>

            <div className="col-4">
              <img
                role="button"
                onClick={() => onHelp("divorce")}
                src="/images/two/8.svg"
                alt="نامه"
                className="img-fluid m-auto  "
              />
            </div>
            <div className="col-4 d-grid ">
              <img
                role="button"
                onClick={() => onHelp("postal")}
                src="/images/two/9.svg"
                alt="نامه"
                className="img-fluid m-auto  "
              />
            </div>
          </div>
          <div className="row  ">
            <div className="col-4"></div>

            <div className="col-4">
              <img
                src="/images/two/10.svg"
                alt="پارچه"
                onClick={() => onHelp("birthday")}
                className="img-fluid m-auto  "
              />
            </div>
            <div className="col-4"></div>
          </div>
          <div className="row justify-content-around">
            <div className="col-4">
              <img
                role="button"
                src="/images/two/11.svg"
                alt="ریسمان"
                onClick={() => onHelp("table")}
                className="img-fluid m-auto "
              />
            </div>
            <div className="col-4">
              <img
                role="button"
                src="/images/two/12.svg"
                alt="نقشه"
                onClick={() => onHelp("picture")}
                className="img-fluid m-auto  "
              />
            </div>
          </div>
          <div className="row  ">
            <div className="col-4"></div>

            <div className="col-4">
              <img
                src="/images/two/13.svg"
                alt="پارچه"
                onClick={() => onHelp("plane")}
                className="img-fluid m-auto  "
              />
            </div>
            <div className="col-4"></div>
          </div>
        </div>
      </div>
    </MasterPage>
  );
};
export default Main2;
